import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

function LearningPathCard({path,videos,progress,t,onOpen}) {
  const completed=videos.filter((video)=> progress[video.id]?.completedAt).length;
  const percent=videos.length ? Math.round((completed / videos.length) * 100) : 0;

  return (
    <article className="path-card">
      <div className="path-card-icon"><SafeIcon icon={FiIcons.FiMap} /></div>
      <span className="training-category">{t.learningPaths}</span>
      <h3>{path.title}</h3>
      <p>{path.description}</p>
      <div className="path-card-meta">
        <span>{completed} / {videos.length} {t.videosCompleted}</span>
        <strong>{percent}%</strong>
      </div>
      <div className="training-progress-track"><span style={{width: `${percent}%`}} /></div>
      <button type="button" className="path-button" onClick={()=> onOpen(path.id)}>
        {completed ? t.continuePath : t.viewPath} <SafeIcon icon={FiIcons.FiArrowRight} />
      </button>
    </article>
  );
}

export default LearningPathCard;